module.exports = __webpack_public_path__ + "static/img/person_1.7d95bb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/person/person_1.jpg
// module id = cyyN
// module chunks = 1